/* Vuex actions for module App */

// import { API, API_URL } from '@/config';
// import { togglePendingStoreActions } from '@/utils/decorators';

import {
  TOOGLE_SOCKET_CONNECTION,
} from './mutations-types';

export default {
  toogleServerSocketConnection({ commit }, stateServer) {
    try {
      commit(TOOGLE_SOCKET_CONNECTION, { stateServer });
    } catch (err) {
      console.log(err);
    }
  },
};
